import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  useTheme,
  Box
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import FilterListIcon from '@mui/icons-material/FilterList';
import DemandFilter from './DemandFilter';

const DemandFilterPopover = ({
  open,
  onClose,
  onApply,
  demandFilterType,
  setDemandFilterType,
  selectedUserTypes,
  handleUserTypesChange,
  userCreationPeriod,
  handleCreationPeriodChange,
  selectedUsers,
  handleSpecificUsersChange,
  usersList,
  userTypeOptions,
  creationPeriodOptions,
  onFilterChange,
  demandYAxisPercentage,
  handleDemandYAxisPercentageChange
}) => {
  const theme = useTheme();

  const handleApply = () => {
    if (onFilterChange) {
      onFilterChange();
    }
    if (onApply) {
      onApply();
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          background: 'linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)'
        }
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: `linear-gradient(135deg, ${theme.palette.primary.main}15 0%, ${theme.palette.primary.main}05 100%)`,
          borderBottom: `2px solid ${theme.palette.primary.main}30`,
          pb: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <FilterListIcon sx={{ color: theme.palette.primary.main }} />
          <span style={{ 
            fontWeight: 700, 
            color: theme.palette.primary.main,
            fontSize: '1.2rem'
          }}>
            Unique Users Filter
          </span>
        </Box>
        <IconButton
          onClick={onClose}
          size="small"
          sx={{
            color: theme.palette.grey[500],
            '&:hover': {
              backgroundColor: theme.palette.grey[100]
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        <DemandFilter
          demandFilterType={demandFilterType}
          setDemandFilterType={setDemandFilterType}
          selectedUserTypes={selectedUserTypes}
          handleUserTypesChange={handleUserTypesChange}
          userCreationPeriod={userCreationPeriod}
          handleCreationPeriodChange={handleCreationPeriodChange}
          selectedUsers={selectedUsers}
          handleSpecificUsersChange={handleSpecificUsersChange}
          usersList={usersList}
          userTypeOptions={userTypeOptions}
          creationPeriodOptions={creationPeriodOptions}
          onFilterChange={onFilterChange}
          demandYAxisPercentage={demandYAxisPercentage}
          handleDemandYAxisPercentageChange={handleDemandYAxisPercentageChange}
        />
      </DialogContent>

      <DialogActions
        sx={{
          p: 3,
          borderTop: `1px solid ${theme.palette.grey[200]}`,
          background: theme.palette.grey[50],
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Box>
          <Button
            onClick={onClose}
            variant="outlined"
            sx={{
              borderRadius: 2,
              px: 3,
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Cancel
          </Button>
        </Box>
        <Box>
          <Button
            onClick={handleApply}
            variant="contained"
            sx={{
              borderRadius: 2,
              px: 3,
              textTransform: 'none',
              fontWeight: 600,
              background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
              boxShadow: `0 4px 12px ${theme.palette.primary.main}30`,
              '&:hover': {
                background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 100%)`,
                boxShadow: `0 6px 16px ${theme.palette.primary.main}40`
              }
            }}
          >
            Apply Filter
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default DemandFilterPopover;
